export default __webpack_public_path__ + "static/media/carrier-global-stack3.webp";